import axios from 'axios';
import * as urls from './urlTypes';

import { toastError } from '../util/toastUtils';

export const getAccountActiovationKeys = async publicId => {
  const url = `${urls.API_GATEWAY_URL}/api/admin-service/account/activationkeys?publicId=${publicId}`;
  const method = 'get';
  try {
    const response = await axios({
      url,
      method,
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    toastError('Api failed to get Account Activation Keys');
    return false;
  }
};
export const generateActivationKey = async data => {
  const url = `${urls.API_GATEWAY_URL}/api/admin-service/account/activationkeys`;
  try {
    const response = await axios({
      url,
      method: 'post',
      withCredentials: true,
      data,
    });

    return response;
  } catch (error) {
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    toastError('Api faild to generate Activation Key');
    return false;
  }
};

export const getActivationKey = async data => {
  const url = `${urls.API_GATEWAY_URL}/api/admin-service/activationkeys/${data.activationKey}`;
  try {
    const response = await axios({
      url,
      method: 'get',
      withCredentials: true,
    });

    return response;
  } catch (error) {
    if (error.response) {
        return {
            error: error.response.data.message,
        };
    }
    toastError('Failed to Copy Activation Key');
    return false;
  }
};
